class RoNotification extends HTMLElement {
  static activeNotifications = {}; // Track active notifications by type

  constructor() {
    super();
    this.timeoutId = null;
    this.currentNotificationType = null;
  }

  connectedCallback() {
    switch (this.dataset.type) {
      case 'wishlist-item-added':
        subscribe(PUB_SUB_EVENTS.wishlistCollectionItemAdded, this.showNotification.bind(this, 'wishlist-item-added'));
        subscribe(PUB_SUB_EVENTS.customerWishlistCollectionItemAdded, this.showNotification.bind(this, 'wishlist-item-added'));
        subscribe(PUB_SUB_EVENTS.wishlistProductItemAdded, this.showNotification.bind(this, 'wishlist-item-added'));
        subscribe(PUB_SUB_EVENTS.customerWishlistProductItemAdded, this.showNotification.bind(this, 'wishlist-item-added'));
        break;

      case 'wishlist-item-removed':
        subscribe(PUB_SUB_EVENTS.wishlistCollectionItemRemoved, this.showNotification.bind(this, 'wishlist-item-removed'));
        subscribe(PUB_SUB_EVENTS.customerWishlistCollectionItemRemoved, this.showNotification.bind(this, 'wishlist-item-removed'));
        subscribe(PUB_SUB_EVENTS.wishlistProductItemRemoved, this.showNotification.bind(this, 'wishlist-item-removed'));
        subscribe(PUB_SUB_EVENTS.customerWishlistProductItemRemoved, this.showNotification.bind(this, 'wishlist-item-removed'));
        break;

      case 'variant-order-max-qty-reached':
        subscribe(PUB_SUB_EVENTS.variantOrderMaxQtyReached, this.showNotification.bind(this, 'variant-order-max-qty-reached'));
        subscribe(PUB_SUB_EVENTS.cartError, this.showNotification.bind(this, 'variant-order-max-qty-reached'));
        break;

      default:
        console.error("data-type (" + this.dataset.type + ") doesn't match or doesn't exist");
    }
  }

  /**
   * Displays a notification of the specified type:
   * 1. Checks if certain opposite notification type is active and closes it if necessary.
   * 2. Clears any existing timeout to prevent overlapping notifications.
   * 3. Opens the notification dialog and adds the class for animation.
   * 4. Sets a timeout to automatically close the notification after 3000ms.
   * 5. Registers the current instance as an active notification in the shared tracker.
   *
   * @param {string} type - The type of notification to display.
   */
  showNotification(type) {
    const notificationDialog = this.querySelector('dialog');

    // Check and close the opposite notification if it's active. ONLY for type wishlist-item-added and wishlist-item-removed
    if (type === 'wishlist-item-added' && RoNotification.activeNotifications['wishlist-item-removed']) {
      RoNotification.activeNotifications['wishlist-item-removed'].closeNotification();
    } 
    else if (type === 'wishlist-item-removed' && RoNotification.activeNotifications['wishlist-item-added']) {
      RoNotification.activeNotifications['wishlist-item-added'].closeNotification();
    }

    // Clear the existing timeout if there is one
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }

    // Show the notification dialog
    this.currentNotificationType = type;
    notificationDialog.classList.add('js-open');
    notificationDialog.show();

    this.timeoutId = setTimeout(() => {
      this.closeNotification();
    }, 3000);

    RoNotification.activeNotifications[type] = this;
  }

  /**
   * Manages notification closing:
   * 1. Clears any existing timeout to prevent automatic closing.
   * 2. Closes the notification dialog and removes the animation class.
   * 3. Removes the instance from the shared active notifications tracking.
   * 4. Resets the current notification type and timeout ID to null.
   */
  closeNotification() {
    const notificationDialog = this.querySelector('dialog');
    
    if (this.timeoutId) {
      clearTimeout(this.timeoutId);
    }
    
    notificationDialog.close();
    notificationDialog.classList.remove('js-open');
    
    // If there is a current notification type, remove this instance from the active notifications tracker
    if (this.currentNotificationType) {
      delete RoNotification.activeNotifications[this.currentNotificationType];
    }
    
    this.currentNotificationType = null; 
    this.timeoutId = null; 
  }
}

customElements.define('ro-notification', RoNotification);
